// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 694 ? "compute" : chunkId) + "." + {"427":"cfd4e3dd","453":"3fee858b","694":"1615aeea","769":"4ba140c6","856":"22c48a80"}[chunkId] + ".chunk.js";
};